import React from 'react'

const Footer = () => {
  return (
    <div className='bg-black text-white text-center py-16'>
        <div className='max-w-[1240px] mx-auto px-4 grid grid-cols-2 lg:grid-cols-5'>
            <div>
                <h3 className='font-bold text-xl border-b-4 border-[#00d8ff] inline-block mt-4'>Products</h3>
                <ul>
                    <li>App</li>
                    <li>Analytics</li>
                    <li>Token List</li>
                    <li>DeFi</li>
                </ul>
            </div>
            <div>
                <h3 className='font-bold text-xl border-b-4 border-[#00d8ff] inline-block mt-4'>Products</h3>
                <ul>
                    <li>App</li>
                    <li>Analytics</li>
                    <li>Token List</li>
                    <li>DeFi</li>
                </ul>
            </div>
            <div>
                <h3 className='font-bold text-xl border-b-4 border-[#00d8ff] inline-block mt-4'>Products</h3>
                <ul>
                    <li>App</li>
                    <li>Analytics</li>
                    <li>Token List</li>
                    <li>DeFi</li>
                </ul>
            </div>
            <div>
                <h3 className='font-bold text-xl border-b-4 border-[#00d8ff] inline-block mt-4'>Products</h3>
    
                <ul>
                    <li>App</li>
                    <li>Analytics</li>
                    <li>Token List</li>
                    <li>DeFi</li>
                </ul>
            </div>
            <div>
                <h3 className='font-bold text-xl border-b-4 border-[#00d8ff] inline-block mt-4'>Products</h3>
                <ul>
                    <li>App</li>
                    <li>Analytics</li>
                    <li>Token List</li>
                    <li>DeFi</li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Footer
